import script from "./Customer-big.vue?vue&type=script&setup=true&lang=js"
export * from "./Customer-big.vue?vue&type=script&setup=true&lang=js"

import "./Customer-big.vue?vue&type=style&index=0&id=23eba0ec&scoped=true&lang=css"
import "./Customer-big.vue?vue&type=style&index=1&id=23eba0ec&scoped=true&lang=css"
import "./Customer-big.vue?vue&type=style&index=2&id=23eba0ec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23eba0ec"]])

export default __exports__